import {
  Box,
  SpaceBetween,
  Link,
  Header,
} from '@amzn/awsui-components-console';
import { AskFusionAssistantButton } from '../fusionAssistant/AskFusionAssistantButton';

const Home = () => {
  return (
    <SpaceBetween direction={'vertical'} size={'s'}>
      <Box padding={{ top: 'xl' }}>
        <Header variant='h1' actions={<AskFusionAssistantButton />}>
          Overview
        </Header>
      </Box>
      <Box variant='p'>
        Fusion Launch Coordinator helps manage documentation tasks for AWS
        service launches and conferences. Use this tool to track launch tasks,
        manage package builds, coordinate buddy launches, and monitor
        documentation status through the full launch lifecycle.
      </Box>
      <Box variant='p'>
        New to the process? Check out the{' '}
        <Link
          href='https://alpha.www.docs.aws.a2z.com/fusion/latest/userguide/fusion-launch-coordinator.html'
          external
        >
          Fusion conference documentation
        </Link>{' '}
        for step-by-step guidance on submitting documentation for conferences.
      </Box>
    </SpaceBetween>
  );
};

export default Home;
